import * as React from 'react';

import classNames from 'classnames';

import { getConfig } from '@base/constants';
// import { isMobileScreen } from '@base/utils';

import * as s from './TopMenuPageTitle.scss';

export interface ITopMenuPageTitleProps {
	title?: string;
	className?: string;
}

// const ANIMATION_TIMEOUT = 200;

export const TopMenuPageTitle: React.FC<ITopMenuPageTitleProps> = ({ className, title }: ITopMenuPageTitleProps) => {
	// const [isLoading, setIsLoading] = React.useState(false);
	const [pageTitle, setPageTitle] = React.useState(title);

	React.useEffect(() => {
		if (pageTitle != title) {
			setPageTitle(title);

			// if (isMobileScreen()) {
			// 	setIsLoading(true);
			//
			// 	setTimeout(() => {
			// 		setPageTitle(title);
			// 		setIsLoading(false);
			// 	}, ANIMATION_TIMEOUT);
			// } else {
			// 	setPageTitle(title);
			// }
		}
	}, [title]);

	return (
		<div title={title} className={classNames(
			s.title,
			className,
			// { [s.titleOut]: isLoading },
		)}>
			{!getConfig().isMobile ? title : pageTitle }
		</div>
	);
};
